/* @flow */
import Store from 'lib/Store';
import Collection from 'lib/Collection';
import GroupStore from 'groups/stores/GroupStore';
import Relationship from 'entities/Relationship';
import { ActionTypes as ChatActionTypes } from 'chat/constants/ChatConstants';
import { ActionTypes } from 'constants/RelationshipConstants';

const Relationships = Collection.extend({ model: Relationship });

class RelationshipStore extends Store {
  getInitialState() {
    return {
      relationships: new Relationships(),
    };
  }

  getRelationship(relationshipId: Backbone$Id): ?Relationship {
    return this.state.relationships.get(relationshipId);
  }

  addRelationship(relationship: Object): void {
    this.state.relationships.add(relationship);
  }

  removeRelationship(relationship: Object): void {
    this.state.relationships.remove(relationship);
  }

  getRelationshipWithUser(userId: Object): ?Relationship {
    return this.state.relationships.find(
      relationship => relationship.getRelatedUser().id === userId
    );
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case ActionTypes.LOAD_RELATIONSHIP:
      case ActionTypes.UPDATE_RELATIONSHIP:
        this.waitFor([GroupStore]);
        this.addRelationship(action.relationship);
        this.emitChange();
        break;
      case ActionTypes.DELETE:
        this.waitFor([GroupStore]);
        this.removeRelationship(this.getRelationshipWithUser(action.userId));
        this.emitChange();
        break;
      case ChatActionTypes.CREATE_CHAT: {
        const otherUserId = action.chat.getOtherChatMembers()[0].id;
        if (action.chat.isGroupChat()) {
          break;
        }
        this.state.relationships.forEach(relationship => {
          const relatedUserId = relationship.getRelatedUser().id;
          if (otherUserId === relatedUserId) {
            relationship.set('chat', action.chat);
          }
        });
        this.emitChange();
        break;
      }
      default:
        break;
    }
  }
}

export default new RelationshipStore();
